; (function (jQuery) {

	"use strict";

	function HeaderSearch() {
		var global = {
			toggle: null,
			searchBar: null,
			searchInput: null,
			closeBtn: null
		};

		var fn = {
			init: function () {
				global.toggle = jQuery('.header__search-toggle');
				global.searchBar = jQuery('.header__search');
				global.searchInput = jQuery('#header-search-field');
				global.closeBtn = jQuery('.header__search-close');

				global.toggle.on('click', function () {
					const isOpen = jQuery(this).attr('aria-expanded') === 'true';
					isOpen ? fn.closeHeaderSearch() : fn.openHeaderSearch();
				});

				global.closeBtn.on('click', function () {
					fn.closeHeaderSearch();
				});

				jQuery(document).on('keydown', function (e) {
					if (e.key === 'Escape' && global.toggle.attr('aria-expanded') === 'true') {
						fn.closeHeaderSearch();
					}
				});
			},

			openHeaderSearch: function() {
				global.searchBar.addClass('is-open');
				global.toggle.attr('aria-expanded', 'true');
				global.searchBar.removeAttr('aria-hidden');
				global.searchBar.find('input, button').attr('tabindex', '0');

				global.searchBar.one('transitionend', () => {
					global.searchInput.trigger('focus');
				});
			},

			closeHeaderSearch: function() {
				global.searchBar.removeClass('is-open');
				global.toggle.attr('aria-expanded', 'false');
				
				global.searchBar.one('transitionend', () => {
					global.searchBar.attr('aria-hidden', 'true');
					global.searchBar.find('input, button').attr('tabindex', '-1');
					global.toggle.trigger('focus');
				});
			}
		}

		jQuery(fn.init);
	}

	new HeaderSearch();
})(jQuery);